import { useEffect } from 'react';

// Sets a unique, SEO-friendly <title> (and optional meta description) for the current page.
export const usePageMeta = (title, description) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute('content', description);
    }
  }, [title, description]);
};
